import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { packages } from "@/mocks/home";

export default function PackageZone() {
  const [notice, setNotice] = useState("");

  const handleAction = (title: string, action: string) => {
    setNotice(`「${title}」${action}为演示操作，本站仅为信息归档展示，暂不提供真实下载。`);
  };

  return (
    <section id="packages" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="03"
          eyebrow="Pack Zone"
          title="打包合集 · 一次取齐整档"
          desc="把同一事件或人物的图集压缩成整包，省去逐页翻找的时间。每个整包都标注收录张数、体积与文件格式，取用前先看清规格。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {packages.map((item) => (
            <article
              key={item.title}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="h-40 w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} 黑料照片打包合集`}
                  title={`${item.title} 高清整包`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className="ri-folder-zip-line text-base"></i>
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

                <dl className="mt-5 grid grid-cols-3 gap-3 border-t border-background-200 pt-4">
                  <div>
                    <dt className="text-[11px] text-foreground-500">收录张数</dt>
                    <dd className="mt-1 font-heading text-sm font-bold text-foreground-950">{item.count}</dd>
                  </div>
                  <div>
                    <dt className="text-[11px] text-foreground-500">整包体积</dt>
                    <dd className="mt-1 font-heading text-sm font-bold text-accent-700">{item.size}</dd>
                  </div>
                  <div>
                    <dt className="text-[11px] text-foreground-500">文件格式</dt>
                    <dd className="mt-1 font-heading text-sm font-bold text-foreground-950">{item.format}</dd>
                  </div>
                </dl>

                <div className="mt-5 flex flex-col gap-2 sm:flex-row">
                  <button
                    type="button"
                    onClick={() => handleAction(item.title, "整包下载")}
                    className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-download-2-line text-base"></i>
                    整包下载
                  </button>
                  <button
                    type="button"
                    onClick={() => handleAction(item.title, "查看详情")}
                    className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    查看详情
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {notice ? (
          <div className="mt-6 flex items-start gap-3 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3 text-sm text-accent-900">
            <i className="ri-information-line mt-0.5 text-base text-accent-600"></i>
            <span className="flex-1">{notice}</span>
            <button
              type="button"
              onClick={() => setNotice("")}
              aria-label="关闭提示"
              className="flex h-6 w-6 items-center justify-center rounded-md text-accent-700 transition-colors hover:bg-accent-100"
            >
              <i className="ri-close-line text-base"></i>
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
}